import { all, spawn } from 'redux-saga/effects';
import {
  getBrowseItemsWatcher,
  getBrowseItemsDebauncedWatcher,
} from './browse-items/sagas';
import {
  getSetWatcher,
  deleteSetWatcher,
  createSetWatcher,
  batchAddToSetWatcher,
  editSetWatcher,
  batchRemoveFromSetWather,
} from './set/sagas';
import { getSetsWatcher } from './sets/sagas';
import { getTagsWatcher } from './tags/sagas';
import { getHistoryWatcher } from './history/sagas';
import {
  getCategoriesWatcher,
  getUserCategoriesWatcher,
  addUserCategoryWatcher,
  removeUserCategoryWatcher,
} from './categories/sagas';
import { getSuggestedItemsWatcher } from './suggested-items/sagas';
import {
  showWarningNotificationWatcher,
  showSuccessNotificationWatcher,
  showErrorNotificationWatcher,
} from './shared/sagas';
// eslint-disable-next-line import/named
import {
  getItemWatcher,
  deleteItemsWatcher,
  batchUpdateItemsWatcher,
  batchUpdateItemsSuccessWatcher,
  updateItemWatcher,
  createItemWatcher,
  likeItemWatcher,
} from './items/sagas';
import {
  getProjectWatcher,
  deleteProjectsWatcher,
  deleteProjectWatcher,
  createProjectWatcher,
  batchAddToProjectWatcher,
  editProjectWatcher,
  batchRemoveFromProjectWatcher,
} from './project/sagas';
import { getUserWatcher, loginWatcher, updateUserWatcher } from './users/sagas';
import { getManufacturersWatcher } from './manufacturers/sagas';
import { getWishlistItemsDebauncedWatcher, getWishlistItemsWatcher } from './wishlist-items/sagas';
import { getProjectItemsWatcher, getProjectItemsDebauncedWatcher } from './project-items/sagas';
import { getStoragesWatcher } from './storages/sagas';
import { createImageWatcher, createImageByUrlWatcher } from './images/sagas';
import { getProjectsWatcher } from './projects/sagas';
import {
  getBarcodeItemsWatcher,
  searchBarcodeItemWatcher,
  validateBarcodeItemWatcher,
} from './barcode-items/sagas';
import { getBarcodeCategoriesWatcher } from './barcode-categories/sagas';
import { getBarcodeManufacturersWatcher } from './barcode-manufacturers/sagas';
import { getItemsCategoriesWatcher } from './items-categories/sagas';
import { getVersionWatcher } from './version/sagas';

export default function* rootSaga() {
  yield all([
    spawn(getBrowseItemsWatcher),
    spawn(getCategoriesWatcher),
    spawn(showWarningNotificationWatcher),
    spawn(showSuccessNotificationWatcher),
    spawn(showErrorNotificationWatcher),
    spawn(getItemWatcher),
    spawn(deleteItemsWatcher),
    spawn(getUserWatcher),
    spawn(updateUserWatcher),
    spawn(getManufacturersWatcher),
    spawn(getWishlistItemsWatcher),
    spawn(getProjectItemsWatcher),
    spawn(getProjectWatcher),
    spawn(deleteProjectsWatcher),
    spawn(getSuggestedItemsWatcher),
    spawn(getSetWatcher),
    spawn(getSetsWatcher),
    spawn(getUserCategoriesWatcher),
    spawn(addUserCategoryWatcher),
    spawn(removeUserCategoryWatcher),
    spawn(getTagsWatcher),
    spawn(batchUpdateItemsWatcher),
    spawn(batchUpdateItemsSuccessWatcher),
    spawn(updateItemWatcher),
    spawn(createItemWatcher),
    spawn(createSetWatcher),
    spawn(getHistoryWatcher),
    spawn(getStoragesWatcher),
    spawn(createImageWatcher),
    spawn(deleteSetWatcher),
    spawn(loginWatcher),
    spawn(likeItemWatcher),
    spawn(deleteProjectWatcher),
    spawn(createProjectWatcher),
    spawn(batchAddToSetWatcher),
    spawn(batchAddToProjectWatcher),
    spawn(editSetWatcher),
    spawn(editProjectWatcher),
    spawn(getProjectsWatcher),
    spawn(batchRemoveFromProjectWatcher),
    spawn(batchRemoveFromSetWather),
    spawn(createImageByUrlWatcher),
    spawn(getBarcodeItemsWatcher),
    spawn(getBarcodeCategoriesWatcher),
    spawn(getBarcodeManufacturersWatcher),
    spawn(validateBarcodeItemWatcher),
    spawn(getItemsCategoriesWatcher),
    spawn(getBrowseItemsDebauncedWatcher),
    spawn(getProjectItemsDebauncedWatcher),
    spawn(getWishlistItemsDebauncedWatcher),
    spawn(getVersionWatcher),
    spawn(searchBarcodeItemWatcher),
  ]);
}
